import { ReactElement } from 'react';

import { Translate } from '@dreryk/react-common';

import { RecipientCategory } from '~libs.shared.prescription';

import { draftPrescriptionsTranslationKeys, prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type PrescriptionCategoryTextViewProps = {
   readonly prescriptionCategory: RecipientCategory;
};

export const PrescriptionCategoryTextView = (props: PrescriptionCategoryTextViewProps): ReactElement => {
   return (
      <StyledPrescriptionTextView
         testId={'prescriptionCategory'}
         compact
         label={prescriptionTranslationKeys.prescriptionCategory}
      >
         <Translate>{draftPrescriptionsTranslationKeys.prescriptionType[props.prescriptionCategory]}</Translate>
      </StyledPrescriptionTextView>
   );
};
